import {
  Button,
  Card,
  CardContent,
  Container,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

const ProjectDetails = () => {
  const { _id } = useParams();
  const [details, setDetails] = useState({});

  useEffect(() => {
    fetch(`https://node-api-vq70.onrender.com/portfolio/${_id}`)
      .then((res) => res.json())
      .then((data) => setDetails(data));
  }, [_id]);

  return (
    <Box sx={{ paddingTop: "3%",}}>
      <Container sx={{ flexGrow: 1 }}>
        <Card style={{ width: "90%", margin: "0 auto" }}>
          <CardContent
            style={{ textAlign: "left", backgroundColor: "#cee8da" }}
          >
            <Typography variant="h6" gutterBottom>
              <img
                style={{ width: "100%", borderRadius: "5px" }}
                src={details.img}
                alt=""
              />
            </Typography>
            <br />
            <Typography
              style={{ fontSize: "bold", marginBottom: "7px" }}
              variant="h5"
            >
              Name - <span style={{ fontSize: "18px" }}>{details.name}</span>
            </Typography>
            <Typography
              style={{ fontSize: "bold", marginBottom: "7px" }}
              variant="h6"
            >
              {details.description}
            </Typography>
            <Typography
              style={{ fontSize: "bold", marginBottom: "7px" }}
              variant="h5"
            >
              Created -{" "}
              <span style={{ fontSize: "18px" }}>{details.created}</span>
            </Typography>
            <Typography
              style={{ fontSize: "bold", marginBottom: "7px" }}
              variant="h5"
            >
              Technologies Used -{" "}
              <span style={{ fontSize: "18px" }}>{details.Technologies}</span>
            </Typography>
            <Typography
              style={{ fontSize: "bold", marginBottom: "7px" }}
              variant="h5"
            >
              Role - <span style={{ fontSize: "18px" }}>{details.role}</span>
            </Typography>
            <Typography variant="h5">
              View Online:
              <Button style={{ fontSize: "16px", color: "red" }}>
                <a
                  style={{ textDecoration: "none" }}
                  rel="noreferrer"
                  target="_blank"
                  href={details.link}
                >
                  {details.name}
                </a>
              </Button>
            </Typography>
            <br />
            <Link style={{ textDecoration: "none" }} to="/#project">
              <Button variant="contained">Back</Button>
            </Link>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default ProjectDetails;
